let activeGameLeaveGuard = null;

export const registerGameLeaveGuard = (guard) => {
  activeGameLeaveGuard = guard;

  return () => {
    if (activeGameLeaveGuard === guard) {
      activeGameLeaveGuard = null;
    }
  };
};

export const runWithGameLeaveGuard = (action) => {
  if (typeof activeGameLeaveGuard === "function") {
    activeGameLeaveGuard(action);
    return;
  }

  action?.();
};
